import en from '../locale/data/en';
import es from '../locale/data/es';
//import 'babel-polyfill';
//import 'core-js/es/set';
//import 'core-js/es/map';

export default {
    en: en,
    es: es
};